import React, { useState } from 'react';
import { XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const DeleteRequestModal = ({ request, onClose, onConfirm, loading = false }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(reason.trim());
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600 mr-2" />
            <h3 className="text-lg font-medium text-gray-900">
              Delete Request
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            disabled={loading}
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">
              Are you sure you want to delete this request?
            </p>
            <div className="bg-gray-50 p-3 rounded-md">
              <p className="text-sm font-medium text-gray-900">
                Account ID: {request?.account_id}
              </p>
              <p className="text-sm text-gray-600">
                {request?.current_bandwidth} → {request?.requested_bandwidth}
              </p>
              <p className="text-sm text-gray-600">
                Status: <span className={`status-badge status-${request?.status}`}>
                  {request?.status}
                </span>
              </p>
            </div>
          </div>

          <div className="mb-6">
            <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-2">
              Reason for deletion (optional)
            </label>
            <textarea
              id="reason"
              name="reason"
              rows={3}
              className="form-input resize-none"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for deleting this request..."
              maxLength={500}
            />
            <p className="mt-1 text-xs text-gray-500">
              {reason.length}/500 characters
            </p>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-6">
            <div className="flex">
              <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-yellow-800">
                <p className="font-medium">This action cannot be undone</p>
                <p>The request will be soft-deleted and can be recovered by system administrators if needed.</p>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-danger"
              disabled={loading}
            >
              {loading ? 'Deleting...' : 'Delete Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteRequestModal;